import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../client";
import type { Member } from "../types";

export function membersKey(slug: string) {
  return ["members", slug] as const;
}

export function useMembers(slug: string): UseQueryResult<Member[], ApiError> {
  return useQuery<Member[], ApiError>({
    queryKey: membersKey(slug),
    queryFn: ({ signal }) => apiFetch<Member[]>(`/api/ws/${slug}/members`, { signal }),
    enabled: !!slug,
  });
}
